"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SuperCropOne = function SuperCropOne(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "61px",
    height: "80px",
    viewBox: "0 0 40 80"
  }, props), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("circle", {
    id: "supercrop-path-1",
    cx: "40",
    cy: "40",
    r: "40"
  })), /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-19.000000, 0.000000)"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#supercrop-path-1"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17,80 C26.8245231,63.1874144 32.7485663,47.2931287 34.7721297,32.3171429 C34.7721297,32.3171429 9.28383334,0.772244159 34.7721297,-12.1971472 C60.260426,-25.1665386 65.0948582,10.0692591 62.6776421,28.1866455 C62.6776421,28.1866455 73.3246986,36.8600727 80,39.3556587 C80,39.3556587 80,47.2071024 80,62.9099899 C68.3182226,57.7245383 60.907229,53.788732 57.7670191,51.102571 C57.7670191,51.102571 49.3184372,75.9707584 46.6161198,80 C46.6161198,80 36.7440799,80 17,80 Z",
    fill: "#000000",
    mask: "url(#mask-2)"
  }))));
};

var SuperCropTwo = function SuperCropTwo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "75px",
    height: "80px",
    viewBox: "0 0 80 80"
  }, props), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("circle", {
    id: "supercrop2-path-1",
    cx: "40",
    cy: "40",
    r: "40"
  })), /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("mask", {
    id: "supercrop2-mask-2",
    fill: "white"
  }, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#supercrop2-path-1"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M-10,62.6675841 C15.4962089,21.097528 36.1750909,0.3125 52.0366458,0.3125 C75.8289781,0.3125 78.2779203,20.6457262 72.1319348,39.0749558 C65.9859492,57.5041854 59.1407262,71.0196681 57.3255016,80.3125 C57.3255016,80.3125 49.0503344,80.3125 32.5,80.3125 C35.642018,68.336358 40.7829689,55.7226932 47.9228526,42.4715057 C58.6326781,22.5947244 50.412723,7.82562547 32.5,35.3066069 C20.5581847,53.6272612 11.0967809,68.6292256 4.11578854,80.3125 L-10,80.3125 L-10,62.6675841 Z",
    fill: "#000000",
    mask: "url(#supercrop2-mask-2)"
  }))));
};

var SuperCropThree = function SuperCropThree(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "80px",
    height: "65px",
    viewBox: "0 0 82 50"
  }, props), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("circle", {
    id: "supercrop3-path-1",
    cx: "40",
    cy: "40",
    r: "40"
  })), /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(0.000000, -15.000000)"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "supercrop3-mask-2",
    fill: "white"
  }, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#supercrop3-path-1"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M-24,55.003681 C-7.69017764,28.9829827 6.7808255,15.9726335 19.4130094,15.9726335 C38.3612853,15.9726335 43.4537618,36.5099206 38.4749216,57.6844365 C38.4749216,57.6844365 64.1653605,7.45479961 104,15.9726335 C104,15.9726335 104,37.315089 104,80 L92.2374608,80 C100.851358,60.557721 102.294148,47.4764814 96.5658307,40.7562814 C87.9733542,30.6759813 64.3652038,43.7336779 46.0384013,80 C46.0384013,80 35.042581,80 13.0509404,80 C20.2520899,58.2201691 22.3727795,45.1389296 19.4130094,40.7562814 C14.9733542,34.1823091 2.08777429,47.6567157 -15.9208464,80 C-15.9208464,80 -18.6138976,80 -24,80 L-24,55.003681 Z",
    fill: "#000000",
    mask: "url(#supercrop3-mask-2)"
  }))));
};

var SUPER_CROPS = [/*#__PURE__*/_react.default.createElement(SuperCropOne, {
  key: "supercrop-1"
}), /*#__PURE__*/_react.default.createElement(SuperCropTwo, {
  key: "supercrop-2"
}), /*#__PURE__*/_react.default.createElement(SuperCropThree, {
  key: "supercrop-3"
})];

var RandomSuperCrop = /*#__PURE__*/function (_React$Component) {
  _inherits(RandomSuperCrop, _React$Component);

  var _super = _createSuper(RandomSuperCrop);

  function RandomSuperCrop() {
    _classCallCheck(this, RandomSuperCrop);

    return _super.apply(this, arguments);
  }

  _createClass(RandomSuperCrop, [{
    key: "render",
    value: function render() {
      var id = this.props.id;
      var modularIndex = parseInt(id, 10) % SUPER_CROPS.length;
      return SUPER_CROPS[modularIndex];
    }
  }]);

  return RandomSuperCrop;
}(_react.default.Component);

exports.default = RandomSuperCrop;

_defineProperty(RandomSuperCrop, "propTypes", {
  // String to mod against to create deterministic
  // supercrop. Will be converted to number.
  id: function id(props, propName, componentName) {
    var prop = props[propName];
    var integerFormOfProp = parseInt(prop, 10);

    if ((0, _isUndefined.default)(prop) && !(0, _isNumber.default)(prop && (0, _isString.default)(prop) && !integerFormOfProp)) {
      return new Error( //eslint-disable-next-line prefer-template
      'Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. Must be parseable to a number.');
    }

    return null;
  }
});

_defineProperty(RandomSuperCrop, "defaultProps", {
  id: 0
});
//# sourceMappingURL=RandomSuperCrop.js.map